import moment from "moment";
import dayjs from "dayjs";
dayjs.extend(require("dayjs/plugin/utc"));

export const convertUTCDateLocal = (utcDate, format) => {
  if (!format) {
    format = "DD/MM/YYYY, HH:mm:ss";
  }

  // Convert UTC date to local date and time
  const localDate = moment.utc(utcDate).local();

  return localDate.format(format);
};

export const convertUTCDate = (date, format) => {
  if (!format) {
    var d = new Date();
    date = new Date(
      dayjs(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes(),
    );
  }
  format = format || "MM/DD/YYYY";
  return dayjs(date).utc().format(format);
};

export const convertToUTCDate = (date, format = "YYYY-MM-DD HH:mm:ss") => {
  if (!date) return null;
  return dayjs(date).utc().format(format);
};

export const convertFromUTCDate = (date, format = "YYYY-MM-DD HH:mm:ss") => {
  if (!date) return null;
  return dayjs.utc(date).local().format(format);
};

export const ConvertTime = (time) => {
  const timePart = time.format("HH:mm");
  return `${timePart}`;
};

export const convertDate = (date) => {
  const datePart = dayjs(date, "MM-DD-YYYY").format("MM/DD/YYYY");
  const time = `${datePart}`;
  return time;
};

export const filterValidValues = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== undefined && value !== null && value !== "",
    ),
  );
};

export const filterCurrentMonthVitals = (dataArray) => {
  const now = new Date();
  const currentMonth = now.getMonth(); // 0-indexed: Jan = 0
  const currentYear = now.getFullYear();

  return dataArray.filter((item) => {
    const itemDate = new Date(item.recordedDateTime);
    return (
      itemDate.getMonth() === currentMonth &&
      itemDate.getFullYear() === currentYear
    );
  });
};
export const calculateAge = (dob) => {
  const dobData = dob;
  const dobYear = dobData?.split("/")[2];
  const currYear = new Date().getFullYear();
  if (dobYear) {
    const patientAge = currYear - Number(dobYear);
    return patientAge;
  }
};

export const POSTAL_CODE_REGEX = {
  // ASIA
  IN: /^[1-9][0-9]{5}$/, // India
  MY: /^\d{5}$/, // Malaysia
  SG: /^\d{6}$/, // Singapore
  TH: /^\d{5}$/, // Thailand
  ID: /^\d{5}$/, // Indonesia
  PH: /^\d{4}$/, // Philippines
  JP: /^\d{3}-?\d{4}$/, // Japan
  KR: /^\d{5}$/, // South Korea
  CN: /^\d{6}$/, // China
  PK: /^\d{5}$/, // Pakistan
  BD: /^\d{4}$/, // Bangladesh
  LK: /^\d{5}$/, // Sri Lanka
  AE: null, // UAE (no postal code)
  HK: null, // Hong Kong (no postal code)

  // NORTH AMERICA
  US: /^\d{5}(-\d{4})?$/, // USA
  CA: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/, // Canada
  MX: /^\d{5}$/, // Mexico

  // EUROPE
  UK: /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s?\d[A-Za-z]{2}$/,
  DE: /^\d{5}$/, // Germany
  FR: /^\d{5}$/, // France
  IT: /^\d{5}$/, // Italy
  ES: /^\d{5}$/, // Spain
  NL: /^\d{4}\s?[A-Za-z]{2}$/, // Netherlands
  BE: /^\d{4}$/, // Belgium
  CH: /^\d{4}$/, // Switzerland
  AT: /^\d{4}$/, // Austria
  SE: /^\d{3}\s?\d{2}$/, // Sweden
  NO: /^\d{4}$/, // Norway
  DK: /^\d{4}$/, // Denmark
  FI: /^\d{5}$/, // Finland
  IE: /^[A-Za-z]\d{2}\s?[A-Za-z\d]{4}$/, // Ireland (Eircode)
  PL: /^\d{2}-\d{3}$/, // Poland
  PT: /^\d{4}-\d{3}$/, // Portugal
  CZ: /^\d{3}\s?\d{2}$/, // Czech Republic
  HU: /^\d{4}$/, // Hungary
  RO: /^\d{6}$/, // Romania
  GR: /^\d{3}\s?\d{2}$/, // Greece

  // OCEANIA
  AU: /^\d{4}$/, // Australia
  NZ: /^\d{4}$/, // New Zealand

  // SOUTH AMERICA
  BR: /^\d{5}-?\d{3}$/, // Brazil
  AR: /^[A-Za-z]\d{4}[A-Za-z]{3}$/, // Argentina
  CL: /^\d{7}$/, // Chile
  CO: /^\d{6}$/, // Colombia
  PE: /^\d{5}$/, // Peru

  // AFRICA
  ZA: /^\d{4}$/, // South Africa
  NG: /^\d{6}$/, // Nigeria
  KE: /^\d{5}$/, // Kenya
  EG: /^\d{5}$/, // Egypt
};

export const validatePostalCode = (countryCode, value) => {
  const regex = POSTAL_CODE_REGEX[countryCode];

  // Countries without postal codes
  if (regex === null) return true;

  // Unknown country → allow but limit length
  if (!regex) return value.length <= 10;

  return regex.test(value);
};
